import WidgetBox from "../WidgetBox/widget-box";
import { CardProps, Text } from "@chakra-ui/react";

type MapProps = CardProps & {
	address?: string | null;
};

export function Map({ address, ...props }: MapProps) {
	return (
		<WidgetBox title="Map" {...props}>
			{address ? (
				<iframe
					title="Property Map"
					width="100%"
					height="100%"
					loading="lazy"
					allowFullScreen
					src={`https://maps.google.com/maps?q=${address}&z=15&output=embed`}
				/>
			) : (
				<Text>No address found</Text>
			)}
		</WidgetBox>
	);
}
